import { defineComponent as _defineComponent } from 'vue'
import UserIcon from '~/assets/img/UserIcon.svg'
import LogoutIcon from '~/assets/img/LogoutIcon.svg'
import InboxIcon from '~/assets/img/InboxIcon.svg'
import FireIcon from '~/assets/img/FireIcon.svg'
import CogIcon from '~/assets/img/CogIcon.svg'
import BriefcaseIcon from '~/assets/img/BriefcaseIcon.svg'
import ReferralsIcon from '~/assets/img/ShareIcon.svg'
import dashboardIcon from '~/assets/img/HomeIcon.svg'
import BookmarkIcon from '~/assets/img/BookmarkSolidIcon.svg'
import QuestionMarkCircleIcon from '~/assets/img/QuestionMarkCircleIcon.svg'
import TalentProfileStatusDraft from '~/assets/img/TalentProfileStatusDraftSm.svg'
import TalentProfileStatusUnderReview from '~/assets/img/TalentProfileStatusUnderReviewSm.svg'
import TalentProfileStatusApproved from '~/assets/img/TalentProfileStatusApprovedSm.svg'
import TalentProfileStatusRejected from '~/assets/img/TalentProfileStatusRejectedSm.svg'
import MagnifyingGlassIcon from '~/assets/img/MagnifyingGlassIcon.svg'
import BoltOutlineIcon from '~/assets/img/BoltOutlineIcon.svg'

import { computed, ref, useContext, useRoute } from '@nuxtjs/composition-api'
import { TalentProfileStatuses } from '~/lib/talentProfileEnums'
import { useLayoutInfo } from '~/lib/composables/useLayoutInfo'
import { useDemoStore } from '~/store/demoStore'
import { onClickOutside } from '@vueuse/core'


export default /*#__PURE__*/_defineComponent({
  __name: 'NavTalent',
  props: {
    isHotlistActive: { type: Boolean },
    isHotlistStatusUpdating: { type: Boolean },
    isHotlistStatusPopupOpen: { type: Boolean }
  },
  emits: ["hotlist-status-popup-changed", "unimpersonate"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'hotlist-status-popup-changed', newIsOpen: boolean): void
  (e: 'unimpersonate'): void
}), expose: any, slots: any, attrs: any }) {





const { $user: user } = useContext()

const profileStatusBadge = computed(() => {
  switch (user.talentProfileStatus) {
    case TalentProfileStatuses.Draft:
      return TalentProfileStatusDraft
    case TalentProfileStatuses.PendingApproval:
      return TalentProfileStatusUnderReview
    case TalentProfileStatuses.Approved:
      return TalentProfileStatusApproved
    case TalentProfileStatuses.Rejected:
      return TalentProfileStatusRejected
    default:
      return null
  }
})

const route = useRoute()
const impersonateCompanyHref = computed(() => {
  return {
    path: route.value.path,
    query: Object.assign({}, route.value.query, { action: 'impersonate-company' }),
  }
})

const impersonateUserHref = computed(() => {
  return {
    path: route.value.path,
    query: Object.assign({}, route.value.query, { action: 'impersonate-user' }),
  }
})

const { isMobileLayout } = useLayoutInfo()

const demoStore = useDemoStore()

function startDemo() {
  demoStore.startDemo()
}

const statusSelectorPopupToggleButtonRef = ref<{ $el: HTMLElement }>()

onClickOutside(
  computed(() => statusSelectorPopupToggleButtonRef.value?.$el),
  () => {
    setTimeout(() => emit('hotlist-status-popup-changed', false))
  },
)

return { __sfc: true,emit, user, profileStatusBadge, route, impersonateCompanyHref, impersonateUserHref, isMobileLayout, demoStore, startDemo, statusSelectorPopupToggleButtonRef, UserIcon, LogoutIcon, InboxIcon, FireIcon, CogIcon, BriefcaseIcon, ReferralsIcon, dashboardIcon, BookmarkIcon, QuestionMarkCircleIcon, MagnifyingGlassIcon, BoltOutlineIcon, TalentProfileStatuses }
}

})